import translate from '../../../i18n'
import { VersionItemTypeOptions } from '../../../pages/versions-container/constant'
import { IVersionFilterParams } from '../../../pages/versions-container/share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const { RangePicker } = DatePicker

const VersionFilter = ({
  onSearch,
  formData,
}: {
  onSearch: (value: IVersionFilterParams) => void
  formData: IVersionFilterParams | undefined
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        createdAtRange:
          formData.createdAtFrom && formData.createdAtTo
            ? [dayjs(formData.createdAtFrom), dayjs(formData.createdAtTo)]
            : undefined,
      })
    }
  }, [form, formData])

  const onFinish = (values: any) => {
    const { createdAtRange, itemId, ...other } = values
    onSearch({
      ...other,
      itemId: itemId ?? undefined,
      createdAtFrom: createdAtRange ? dayjs(createdAtRange[0]).utc().format() : undefined,
      createdAtTo: createdAtRange ? dayjs(createdAtRange[1]).utc().format() : undefined,
    })
  }

  return (
    <Form form={form} layout="inline" style={{ gap: '8px' }} onFinish={onFinish}>
      <Form.Item name="itemType" label={translate('version.itemType')}>
        <Select style={{ minWidth: 150 }} allowClear options={VersionItemTypeOptions} />
      </Form.Item>
      <Form.Item name="itemId" label={translate('version.itemId')}>
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="eventName" label={translate('version.eventName')}>
        <Input allowClear />
      </Form.Item>
      <Form.Item name="createdAtRange" label={translate('createdAt')}>
        <RangePicker
          showTime={{
            defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
          }}
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          {translate('search')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default VersionFilter
